/**
 * Pages réservées à chaque module de l'offre. Une clinique qui n'a pas le
 * module ne voit ni le menu, ni la page (même en tapant l'adresse) ; le
 * serveur refuse de son côté les routes correspondantes (App\Plateforme\Modules).
 */
const PAGES_PAR_MODULE = [
  ['PHARMACIE', /^\/(produits|approv|approvs|approvisionnements|medicaments|stocks-lots|ventes)(\/|$)/],
  ['HOSPITALISATION', /^\/(hospitalisation|hospitalisations|recu_hospitalisation|chambres|lits|type_chambres|type_hospitalisation|type_hospitalisations)(\/|$)/],
  ['HOSPITALISATION', /^\/dossiers\/[^/]+\/hospitalisations/],
  ['ASSURANCES', /^\/(assurances|creances-assurance)(\/|$)/],
  ['ASSURANCES', /^\/dossiers\/[^/]+\/assurances/],
  ['LABORATOIRE', /^\/(laboratoire|type_examens)(\/|$)/],
  ['DOCUMENTS', /^\/dossiers\/[^/]+\/documents/],
  ['RENDEZ_VOUS', /^\/(rendez-vous|heures-consultation)(\/|$)/],
  ['FINANCES', /^\/finances\/(rapports|depenses|honoraires)(\/|$)/],
  ['PAIEMENT_EN_LIGNE', /^\/(paiements-en-ligne|paiement-en-ligne)(\/|$)/],
  ['SMS', /^\/journal-sms(\/|$)/],
  ['BANQUE_SANG', /^\/banque-sang(\/|$)/],
]

/** Module nécessaire pour ouvrir cette adresse, ou null (socle). */
export function moduleDe(chemin) {
  const p = String(chemin || '').split('?')[0]
  const trouve = PAGES_PAR_MODULE.find(([, re]) => re.test(p))
  return trouve ? trouve[0] : null
}

export const NOMS_MODULES = {
  RENDEZ_VOUS: 'Rendez-vous et agenda',
  PHARMACIE: 'Pharmacie et stock',
  LABORATOIRE: 'Laboratoire',
  HOSPITALISATION: 'Hospitalisation',
  ASSURANCES: 'Assurances',
  DOCUMENTS: 'Documents médicaux',
  FINANCES: 'Finances',
  PAIEMENT_EN_LIGNE: 'Paiement en ligne',
  SMS: 'SMS patients',
  BANQUE_SANG: 'Banque de sang',
}
